import config from "./config";


function createImageApi(params) {
	return Ajax.post(config.createImage, params, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
export { 
	createImageApi 
};



// WEBPACK FOOTER //
// ./src/api/privateInstance/list/actions.js